/* eslint-disable */
/**
 * Strip HTML function.
 *
 * @param  {string}  html
 * @return {string}
 */
export const stripHtml = html => String(html)
  .replace(/<[^>]*>?/gm, '')
  .replace(/(&nbsp;)+/gm, ' ')
